




























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import WorkHttp from '@/http/WorkHttp';
import Dialog from '@/components/Dialog.vue';
import { Product } from '@/store/types/work/invoice';

@Component({
  components: { Dialog }
})
export default class ChangeProductValue extends Vue {
  @Prop() showDialog!: boolean;
  @Prop() outgoing!: boolean;
  @Prop() value!: Product;
  @Watch('value', { immediate: true, deep: true })
  onValueChanged (newVal: any) {
    this.formData = {
      real_value: newVal.real_value
    };
  }
  public loading = false;
  valid = false;
  formData = {
    real_value: 1
  }

  get computedProduct () {
    return {
      title: this.outgoing ? this.value.from_product_title : '',
      enterprise_id: this.outgoing ? this.value.from_enterprise_id : this.value.enterprise_id,
      id: this.outgoing ? this.value.from_product_id : this.value.product_id
    };
  }

  public change () {
    this.loading = true;
    (new WorkHttp(this.computedProduct.enterprise_id || 0)).post({
      url: `/invoices/${this.outgoing ? 'outgoing' : 'income'}/${this.value.invoice_id}/products/${this.computedProduct.id}/real-value`,
      data: this.formData
    })
      .then(_ => {
        this.$emit('save');
      }).catch(e => {
        alert('Сталась помилка під час запиту.');
      }).then(_ => {
        this.loading = false;
      });
  }
}
